import api from './axiosConfig.js'

export const shiftApi = {
  // Shift management
  createShift: (shiftData) =>
    api.post('/shifts/create-shift', shiftData, {
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),

  listShifts: (params = {}) =>
    api.get('/shifts/list-shifts', {
      params,
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),

  getShift: (shiftId) =>
    api.get(`/shifts/get-shift?id=${shiftId}`, {
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),

  updateShift: (shiftId, shiftData) =>
    api.put(`/shifts/update-shift?id=${shiftId}`, shiftData, {
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),

  deleteShift: (shiftId) =>
    api.delete(`/shifts/delete-shift?id=${shiftId}`, {
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),

  // Shift assignments
  assignShift: (assignmentData) =>
    api.post('/employee-shifts/assign', assignmentData, {
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
      skipSuccessToast: true
    }),

  updateAssignment: (assignmentData) =>
    api.put('/employee-shifts/update', assignmentData, {
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') },
      skipSuccessToast: true
    }),

  getAssignments: (params = {}) =>
    api.get('/employee-shifts/assignments', {
      params,
      headers: { 'X-ORG-ID': localStorage.getItem('org_id') }
    }),
}